import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-accessible-policy',
    templateUrl: './accessible-policy.component.html',
    styleUrls: ['./accessible-policy.component.scss'],
    standalone: false
})
export class AccessiblePolicyComponent implements OnInit 
{

  constructor(
    public translateService: TranslateService
  ) 
  { 
  }

  ngOnInit() 
  {
  }

}
